import { Key } from "antd/lib/table/interface";
import { Close } from "assets/icons";
import classNames from "classnames";
import { TFunction } from "i18next";
import React, { Dispatch, ReactNode, SetStateAction } from "react";
import "./ActionBarComponent.scss";

export interface ActionBarComponentProps {
  children?: ReactNode;
  /** SelectedRowKeys of table */
  selectedRowKeys?: Key[];
  /** SetSelectedRowKeys of table*/
  setSelectedRowKeys?: Dispatch<SetStateAction<Key[]>>;
  /**Handle cancel selection */
  handleCancelAction?: () => void;
  /**Row selection */
  rowSelections?: any;
  translate?: TFunction;
}

function ActionBarComponent(props: ActionBarComponentProps) {
  const {
    children,
    selectedRowKeys = [],
    handleCancelAction,
    setSelectedRowKeys,
    translate,
  } = props;

  const handleCancel = React.useCallback(() => {
    if (typeof handleCancelAction !== "undefined") {
      handleCancelAction();
    } else {
      setSelectedRowKeys([]);
    }
  }, [setSelectedRowKeys, handleCancelAction]);

  return (
    <div
      className={classNames(
        "action-bar-container",
        selectedRowKeys?.length > 0
          ? "action-bar-active"
          : "action-bar-inactive"
      )}
    >
      <div className="title-and-action">
        <div className="item-selected-counter">
          {translate("CM.actionbar.selected")} {selectedRowKeys?.length} {translate("CM.actionbar.lines")}
        </div>
        <div className="line-verticle"></div>
        {children}
      </div>

      {selectedRowKeys?.length > 0 && (
        <div className="action-button">
          <Close fillColor="white" onClick={handleCancel} />
        </div>
      )}
    </div>
  );
}
export default ActionBarComponent;
